import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import AuditQuestionCard from "./AuditQuestionCard";

import { createEmptyResponse } from "../utils/operationalAuditResponses";
import { formatOperationalAuditEnum } from "../utils/operationalAuditFormatting";

const AuditAreaAccordion = ({
  area,
  questions,
  responses,
  auditLocked,
  onUpdateResponse,
  onProcessStatusChange,
  onDocumentationStatusChange,
}) => {
  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography fontWeight="bold">
          {formatOperationalAuditEnum(area)} (
          {questions.length})
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Box
          display="flex"
          flexDirection="column"
          gap={3}
        >
          {questions.map((question) => (
            <AuditQuestionCard
              key={question.id}
              question={question}
              response={
                responses[question.id] ||
                createEmptyResponse()
              }
              auditLocked={auditLocked}
              onUpdate={(patch) =>
                onUpdateResponse(
                  question.id,
                  patch,
                )
              }
              onProcessStatusChange={(status) =>
                onProcessStatusChange(
                  question.id,
                  status,
                )
              }
              onDocumentationStatusChange={(
                status,
              ) =>
                onDocumentationStatusChange(
                  question.id,
                  status,
                )
              }
            />
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default AuditAreaAccordion;